import React, { useMemo, useState } from 'react';

import { ProgressIndicator } from '@atlaskit/progress-indicator';

import {
	CarouselControlsStyled,
	SlideContainer,
	SlideTextStyled,
	CarouselSlide,
} from '../../styled/StyledModal';
import { useGetBenefits } from '../../hooks/useGetBenefits';

import { PreviousButton } from './buttons/PreviousButton';
import { NextButton } from './buttons/NextButton';

export function Carousel() {
	const [activeSlide, setActiveSlide] = useState(0);
	const benefits = useGetBenefits();
	const slides = useMemo(
		() => {
			return Object.keys(benefits).map((key: string) => ({
				name: benefits[key].benefit,
				slide: <CarouselSlide src={benefits[key].img} alt={benefits[key].benefit} />,
			}));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			/* Fire only on mount */
		],
	);

	return (
		<div>
			<SlideContainer>{slides[activeSlide].slide}</SlideContainer>
			<SlideTextStyled>{slides[activeSlide].name}</SlideTextStyled>
			<CarouselControlsStyled>
				<PreviousButton activeSlide={activeSlide} setActiveSlide={setActiveSlide} />
				<ProgressIndicator selectedIndex={activeSlide} values={slides} appearance="primary" />
				<NextButton
					activeSlide={activeSlide}
					setActiveSlide={setActiveSlide}
					slideLength={slides.length}
				/>
			</CarouselControlsStyled>
		</div>
	);
}
